import { useSize } from 'ahooks';
import { useEffect } from 'react';

export const useSetBody = () => {
  const { width = 750 } = useSize(document.documentElement) ?? {};

  useEffect(() => {
    // 移动端
    if (width < 525) {
      document.documentElement.style.fontSize = (width / 750) * 100 + 'px';
    } else {
      document.documentElement.style.fontSize = '68px';
    }
  }, [width]);
};
